module.exports = __webpack_public_path__ + "img/new_home_logo.5b550ec5.png";